// import Backbone from 'backbone'
import Sku from '../models/sku';
import namespace from '../../upi/namespace';

var app = namespace( 'apps.productpage' );

/* Treat SkuItemView as a layout Controller with child views */
var skuItemController = Backbone.View.extend( {

    el: '#body-content',

    initialize: function () {

        this.model = new Sku;

        this.listenTo( this, 'sku:updated', this.render );
        this.listenTo( app.mediator, 'set:sku', this.setSku );
        this.listenTo( app.mediator, 'unset:sku', this.unsetSku );
    },

    render: function () {
        this.toggleSupplementaryContent();
    },

    setSku: function ( sku ) {
        sku = sku || new Sku; // pass empty Sku to clear panel if selection not present

        // make sure we have a sku and not already selected before sending tracking event
        if ( sku && !sku.get( 'selected' ) && sku.get( 'id' ) !== 'noop' ) {
            sku.getCatalogDetail()
                .then( item => app.dataLayer.product.sendProductView( item ) )
                .catch( err => console.error( `[Analytic Event Error] Failed to send product view - ${err}` ) );
        }

        this.toggleSelect( sku );
        this.model = sku;
        this.trigger( 'sku:updated' );
    },

    unsetSku: function () {
        this.model.select( false );
        this.model = new Sku; // id:noop
    },

    getQuantity: function () {
        return app.priceModuleView.getQuantity();
    },

    toggleSelect: function ( sku ) {
        // unset previous selection
        this.model.select( false );

        // if sku not null, set as current selection
        if ( sku ) {
            sku.select( true );
        }
    },

    toggleSupplementaryContent: function () {
        // only update supplementary content if sku is in "selected" state
        if ( this.model.get( 'selected' ) ) {
            this.togglePrintingMessage();
            this.updateImageCollection();
        }
    },

    togglePrintingMessage: function () {
        app.mediator.trigger( 'toggle:customprinting', this.model.get( 'isCustomPrintable' ) );
    },

    updateImageCollection: function () {
        var imageCollection = this.model.get( 'images' );
        if ( imageCollection.length ) {
            app.imageCollection.reset( imageCollection );
        }
    },

    close: function () {
        this.undelegateEvents();
        this.stopListening( this.model );
        this.stopListening( app.mediator );
    }

} );

export default skuItemController;
